import { render, staticRenderFns } from "./TeamDates.vue?vue&type=template&id=39a6bc42&"
import script from "./TeamDates.vue?vue&type=script&lang=js&"
export * from "./TeamDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports